var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcStarRating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6890_5381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.12443 16.6426H5.40625V23.2974H8.12443V16.6426Z",
    stroke: "#008CFF",
    strokeWidth: 1.40595,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3782 23.2974C16.2547 23.2974 17.0005 22.659 17.1359 21.793L17.715 18.087C17.8835 17.008 17.0493 16.0333 15.9572 16.0333H14.03V14.0454C14.03 12.7879 13.0106 11.7686 11.7532 11.7686H11.0775V13.9438C11.0775 15.4343 9.86923 16.6425 8.37873 16.6425H8.125V23.2974H15.3782Z",
    stroke: "#008CFF",
    strokeWidth: 1.40595,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8274 7.21875L21.0376 8.74149L22.8598 9.42197L21.7856 11.0435L21.7015 12.9868L19.8274 12.4662L17.9532 12.9868L17.8692 11.0435L16.7949 9.42197L18.6171 8.74149L19.8274 7.21875Z",
    stroke: "#008CFF",
    strokeWidth: 1.40595,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17406 7.21875L5.3843 8.74149L7.20651 9.42197L6.13227 11.0435L6.04819 12.9868L4.17406 12.4662L2.29992 12.9868L2.21584 11.0435L1.1416 9.42197L2.96381 8.74149L4.17406 7.21875Z",
    stroke: "#008CFF",
    strokeWidth: 1.40595,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0139 1.12988L13.2241 2.65262L15.0463 3.33306L13.9721 4.95464L13.888 6.8979L12.0139 6.37737L10.1397 6.8979L10.0556 4.95464L8.98145 3.33306L10.8036 2.65262L12.0139 1.12988Z",
    stroke: "#008CFF",
    strokeWidth: 1.40595,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6890_5381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarRating);
export default __webpack_public_path__ + "static/media/ic-star-rating.a88eb00b08356c20a9119f1cafef53e0.svg";
export { ForwardRef as ReactComponent };